/**
 * Global error suppression for scanner-related errors
 * This file should be imported as early as possible in the app
 */

// Store original handlers
const originalError = console.error;
const originalWarn = console.warn;

// Override console.error to suppress scanner errors
console.error = (...args) => {
    const errorString = args.join(' ');
    if (
        errorString.includes('BarcodeDetector') ||
        errorString.includes('Barcode detection service unavailable') ||
        errorString.includes('wasm') ||
        errorString.includes('Aborted') ||
        errorString.includes('async and sync fetching')
    ) {
        // Silently suppress these errors
        return;
    }
    originalError.apply(console, args);
};

// Override console.warn to suppress scanner warnings
console.warn = (...args) => {
    const warnString = args.join(' ');
    if (
        warnString.includes('BarcodeDetector') ||
        warnString.includes('Barcode detection service unavailable')
    ) {
        // Silently suppress these warnings
        return;
    }
    originalWarn.apply(console, args);
};

// Global error handler
window.addEventListener('error', (event) => {
    const errorMessage = event?.message || event?.error?.message || '';
    if (
        errorMessage.includes('BarcodeDetector') ||
        errorMessage.includes('Barcode detection service unavailable') ||
        errorMessage.includes('wasm') ||
        errorMessage.includes('Aborted') ||
        errorMessage.includes('async and sync fetching')
    ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
    }
}, true); // Use capture phase

// Global unhandled rejection handler
window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event?.reason?.message || event?.reason?.toString() || '';
    if (
        errorMessage.includes('BarcodeDetector') ||
        errorMessage.includes('Barcode detection service unavailable') ||
        errorMessage.includes('wasm') ||
        errorMessage.includes('Aborted') ||
        errorMessage.includes('async and sync fetching')
    ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
    }
}, true); // Use capture phase

console.log('[ErrorSuppression] Global scanner error suppression initialized');
